// Which release the account menu’s dot has already been shown for. `localStorage`, not
// `sessionStorage` like `invite-stash.ts` and `return-path-stash.ts` — those die with the
// tab on purpose, a badge that reset every time someone opened a new tab would not.
// `preferences.ts` is the other `localStorage` user in this package, but it is shaped for a
// fixed set of values with a fallback; a release id has neither, so this gets its own
// small module in the same subscribable-stash style as the two above.

const STORAGE_KEY = 'mor.releaseNotes.seenId';

const listeners = new Set<() => void>();

export function subscribeSeenRelease(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function seenReleaseId(): string | null {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    // A browser that refuses the store reads as "nothing recorded", which the dot's own
    // rule — first sight never badges — turns into no dot, ever, rather than a dot nobody
    // can clear. The quiet failure is the right one for a badge.
    return null;
  }
}

export function markReleaseSeen(id: string): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, id);
  } catch {
    // As above.
  }
  for (const listener of listeners) {
    listener();
  }
}
